<template>
  <div>
    <PreCalificacionCustomerDetail v-if="type === 'PreCalificacionCustomer'" :model="object" :on-success="actions"/>
    <ActividadEconomicaDetail v-if="type === 'ActividadEconomicaCustomer'" :model="object" :on-success="actions"/>
    <BanksDetails v-if="type === 'Banks'" :model="object" :on-success="actions"/>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import PreCalificacionCustomerDetail from '@/components/details/PreCalificacionCustomerDetail'
import ActividadEconomicaDetail from '@/components/details/ActividadEconomicaDetail'
import BanksDetails from '@/components/details/BanksDetails'
export default {
  props: ['object', 'type', 'itemsAction'],
  data: () => ({}),
  mounted () {},
  methods: {
    ...mapActions([]),
    ...mapMutations([]),
    actions (actons) {
      this.itemsAction(actons)
    }
  },
  computed: {
    ...mapGetters([])
  },
  components: {
    PreCalificacionCustomerDetail,
    ActividadEconomicaDetail,
    BanksDetails
  },
  watch: {},
  beforeDestroy () {}
}
</script>

<style>
</style>
